import { AiDocumentType } from '../domain/enums/ai-document-type';

const DOCUMENT_TYPE_LABELS: Record<number, string> = {
   [AiDocumentType.Other]: 'Other',
   [AiDocumentType.PmAccounts]: 'PM Accounts',
   [AiDocumentType.CreditLimit]: 'Credit Limit',
   [AiDocumentType.ComplimentaryRooms]: 'Complimentary Rooms',
   [AiDocumentType.OutOfOrderRooms]: 'Out of Order Rooms',
   [AiDocumentType.NoShowRooms]: 'No Show Rooms',
   [AiDocumentType.HousekeepingDiscrepancy]: 'Housekeeping Discrepancy',
   [AiDocumentType.PaidOut]: 'Paid Out',
   [AiDocumentType.KeyRegister]: 'Key Register',
   [AiDocumentType.RevenueAdjustment]: 'Revenue Adjustment',
   [AiDocumentType.TaComm]: 'TA Comms',
   [AiDocumentType.RateChange]: 'Rate Change Report',
   [AiDocumentType.PaymentRefunds]: 'Payment Refunds'
};

export function documentTypeToLabel(
   type: AiDocumentType | number | null | undefined
): string {
   if (type === null || type === undefined) return 'Unknown';

   const key = typeof type === 'number' ? type : (type as unknown as number);
   return DOCUMENT_TYPE_LABELS[key] ?? 'Unknown';
}
